const initialState = {
    data: null,
}
export const SendReportEmailReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SENDREPORTEMAIL_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'SENDREPORTEMAIL_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default SendReportEmailReducer;